import React from 'react';
import { SubJobClosedAppointment } from 'models';
import { Colors } from 'library';
import SubJobAppointmentBaseCard from './Table/components/SubJobAppointmentBaseCard';

export default function SubJobClosedAppointmentEntry({ appt }: { appt: SubJobClosedAppointment }) {
    return <SubJobAppointmentBaseCard appt={appt} cardColor={Colors.mediumGrey} textColor={Colors.white} />;
}
